export default "__VITE_ASSET__b5b9493d__"